import { MetricDefinitionConstants } from './MetricDefinition.constants';

const initialState = {
  metricDefinition: [],
  metricsDisplayMapping: [],
  mapping: {
    list: []
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case MetricDefinitionConstants.GET_METRIC_DEFINITION:
      return {
        ...state,
        metricDefinition: action.payload
      };

    case MetricDefinitionConstants.GET_CHROME_METRICS_SUCCESS:
      return {
        ...state,
        chromeMetrics: action.payload
      };

    // --- GEt Mapping list
    case MetricDefinitionConstants.GET_MAPPING_REQUEST:
      return {
        ...state,
        mapping: {
          loading: true,
          error: false
        }
      };

    case MetricDefinitionConstants.GET_MAPPING_SUCCESS:
      return {
        ...state,
        mapping: {
          loading: false,
          error: false,
          list: action.payload
        }
      };

    case MetricDefinitionConstants.GET_MAPPING_ERROR:
      return {
        ...state,
        mapping: {
          loading: false,
          error: true
        }
      };

    case MetricDefinitionConstants.UPDATE_METRICS_DISPLAY_MAPPING:
      return {
        ...state,
        metricsDisplayMapping: action.payload
      };

    default:
      return {
        ...state
      };
  }
}
